import { useMemo } from 'react';

import { useTabContentConfig } from '../../components/PageConfigProvider/PageConfigProvider';
import type { MetricValues } from '../../components/PageConfigProvider/types/metric';
import { usePageState } from '../../components/PageState/PageStateProvider';
import { getRevelioPageOverrides } from '../../utils/getRevelioPageOverrides';

// Metrics requiring 'week' granularity
const weeklyMetrics: Partial<Record<MetricValues, boolean>> = {
  posting_salary: true,
  time_to_fill: true,
  postings_active: true,
  postings_new: true,
  postings_removed: true,
  postings_volume: true,
  contractor_pay_rate: true,
  base_salary: true,
  total_compensation: true,
  salary_growth: true,
};

export const useViewDateGranularity = (): 'week' | 'month' => {
  const { config } = useTabContentConfig();
  const { items } = config;
  const { pageState } = usePageState();

  const viewGranularity = useMemo(() => {
    const hasWeeklyMetric = items.some((item) => {
      const { defaultMetric } = getRevelioPageOverrides(item);
      const metric = pageState.metricOverrides?.[item.id] ?? defaultMetric;

      return metric ? Boolean(weeklyMetrics[metric]) : false;
    });

    return hasWeeklyMetric ? 'week' : 'month';
  }, [items, pageState.metricOverrides]);

  return viewGranularity;
};
